import { render } from "./Factory.vue?vue&type=template&id=8d3e541e&scoped=true&ts=true"
import script from "./Factory.vue?vue&type=script&lang=ts"
export * from "./Factory.vue?vue&type=script&lang=ts"

import "./Factory.vue?vue&type=style&index=0&id=8d3e541e&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d3e541e"]])

export default __exports__